export default {
  key: 'vue',
  lang: 'html',
  generate: ({ baseUrl, websiteToken }) => `
<!-- src/components/TolaWidget.vue -->
<script setup>
import { onMounted } from 'vue';

const BASE_URL = '${baseUrl}';
const WEBSITE_TOKEN = '${websiteToken}';
const SCRIPT_ID = 'tola-sdk';

onMounted(() => {
  // The SDK is a global singleton, so inject it only once.
  if (document.getElementById(SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.src = BASE_URL + '/packs/js/sdk.js';
  script.async = true;
  script.onload = () => {
    window.tolaSDK.run({ websiteToken: WEBSITE_TOKEN, baseUrl: BASE_URL });
  };
  document.head.appendChild(script);
});
</script>

<template>
  <!-- Tola mounts its own launcher on document.body -->
</template>

<!--
  Usage: import TolaWidget from './components/TolaWidget.vue' in App.vue
  and render <TolaWidget /> once, at the root of your app.
-->
`,
};
